module.exports = __webpack_public_path__ + "img/icon_e.49cf8860.png";